import React from "react";
import { Link } from "react-router-dom";
import { Crown, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Paywall } from "../components/Premium";
import { SectionLabel, Button } from "../components/Primitives";

export default function Premium() {
  const { user } = useAuth();

  if (user?.is_premium) {
    return (
      <div className="mx-auto max-w-2xl px-6 py-16 md:px-12" data-testid="premium-active-page">
        <div className="border border-gold/60 bg-ash p-8 md:p-10 text-center">
          <Crown className="mx-auto h-10 w-10 text-gold" />
          <SectionLabel>Premium Active</SectionLabel>
          <h2 className="mt-2 font-serif text-3xl font-semibold text-bone">You have full access</h2>
          <p className="mt-4 text-muted">
            Lessons, Quizzes, Assignments, the AI Tutor and Certificates are all unlocked. Thank you for supporting Our African Narratives.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/lessons"><Button variant="gold" data-testid="premium-lessons-btn">Browse Lessons <ArrowRight className="h-4 w-4" /></Button></Link>
            <Link to="/tutor"><Button variant="outline" data-testid="premium-tutor-btn">Ask the Tutor</Button></Link>
          </div>
        </div>
      </div>
    );
  }
  return <Paywall />;
}
